import { forwardRef, ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Fade,
  Grid,
  Divider,
  IconButton,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { CircularLoading } from 'views/components/utils/circular-loading/circular-loading';
import { CloseIcon } from 'views/components/icons/close-icon';
import { useStyles } from './dialog-saurus-styles';
import { useThemeQueries } from 'views/theme';
import classNames from 'classnames';

export interface DialogSaurusProps {
  aberto?: boolean;
  children?: ReactNode;
  icone?: ReactNode;
  carregando?: boolean;
  titulo?: string;
  colorTitulo?: string;
  centralizarTitulo?: boolean;
  tamanho?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  zIndex?: string;
  isButtonTitleClose?: boolean;
  endAdornment?: JSX.Element;
  fullScreen?: boolean;
  bottomArea?: ReactNode;
  isDivider?: boolean;
  handleClickClose?: () => void;
  titleClasses?: string
  fullHeight?: boolean;
}
const Transition = forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Fade timeout={500} ref={ref} {...props} />;
});

export const DialogSaurus = ({
  aberto,
  children,
  icone,
  carregando,
  centralizarTitulo,
  colorTitulo,
  titulo,
  tamanho,
  zIndex,
  isButtonTitleClose,
  endAdornment,
  fullScreen,
  bottomArea,
  isDivider,
  titleClasses,
  fullHeight,
  handleClickClose,
}: DialogSaurusProps) => {
  const classes = useStyles();
  const { theme } = useThemeQueries();
  return (
    <Dialog
      maxWidth={tamanho || 'lg'}
      open={aberto || false}
      PaperProps={fullHeight ? {
        className: classNames(classes.fullHeight)
      } : undefined}
      fullWidth
      disableScrollLock
      keepMounted
      disableEscapeKeyDown
      TransitionComponent={Transition}
      fullScreen={fullScreen}
      ref={(el: any) => {
        if (el && (zIndex || '').length > 0) {
          el.style.setProperty('z-index', zIndex, 'important');
        }
      }}
    >
      {(isButtonTitleClose || titulo) && (
        <DialogTitle disableTypography style={{ padding: '16px' }}>
          {isButtonTitleClose ? (
            <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid container alignItems='flex-start' direction='row'>
                {icone ? icone : null}
                <Typography variant="h6">
                  <strong style={{ color: colorTitulo ? colorTitulo : '#7A7A7A' }}>
                    {titulo}
                  </strong>
                </Typography>
              </Grid>
              <IconButton
                className={classes.closeButton}
                onClick={handleClickClose}
              >
                <CloseIcon tipo="BUTTON" fill="#666" style={{ width: 30 }} />
              </IconButton>
            </Grid>
          ) : (
            <Grid
              style={{
                display: 'flex',
                justifyContent: centralizarTitulo ? 'center' : 'space-between',
                alignItems: 'center',
              }}
            >
              {icone ? icone : null}
              <Typography variant="h6">
                <strong style={{ color: colorTitulo ? colorTitulo : '#7A7A7A' }}>
                  {titulo}
                </strong>
              </Typography>
              {endAdornment || <></>}
            </Grid>
          )}
          {isDivider &&
            <Divider style={{ background: theme.palette.primary.main, height: '2px' }} />
          }
        </DialogTitle>
      )}
      <DialogContent style={
        fullScreen ? {
          padding: '1rem'
        } : {}
      }>
        {carregando ? <CircularLoading tipo="FULLSIZED" /> : children}
      </DialogContent>
      {bottomArea && <div>
        {bottomArea}
      </div>}
    </Dialog>
  );
};
